import _ from 'lodash'
import readingType from '../../lib/readingType'

export default (readings) => _.find(readings, readingType('Signal Strength'))
